import { Injectable } from '@angular/core';
import { MetaMaskSDK } from '@metamask/sdk';
import { concatMap, from, lastValueFrom, Observable } from 'rxjs';
import { PersonalSignDTO } from '../components/login/login.component';

@Injectable({
  providedIn: 'root',
})
export class MetamaskService {
  private readonly MMSDK: MetaMaskSDK;

  constructor() {
    this.MMSDK = new MetaMaskSDK();
  }

  public getAccountId(): Promise<string[]> {
    let observable = from(this.MMSDK.connect()).pipe(
      concatMap(() => {
        const provider = this.MMSDK.getProvider();
        if (!provider) {
          throw new Error('Provider not available');
        }
        return from(
          provider.request({ method: 'eth_requestAccounts' })
        ) as Observable<string[]>;
      })
    );
    return lastValueFrom(observable);
  }

  public signMessage(accountId: string, nonce: string) {
    const observable = from(
      this.MMSDK.getProvider()!
        .request({
          method: 'personal_sign',
          params: [nonce, accountId],
        })
        .then((signature: any | string) => {
          return { nonce, accountId, signature } as unknown as PersonalSignDTO;
        })
    );
    return lastValueFrom(observable);
  }
}
